import $ from 'jquery'
import { Fancybox } from '../../../node_modules/@fancyapps/ui/dist/fancybox/fancybox.esm'
import Swiper from 'swiper/bundle'
import hcSticky from 'hc-sticky'
import { modalAlertTemplate } from '../functions'
import { Modal } from 'bootstrap'

// eslint-disable-next-line no-undef
const object = casanovaObject

let thumbnails

if (document.querySelector('.seedling-thumbnails')) {
  thumbnails = new Swiper('.seedling-thumbnails', {
    direction: 'vertical',
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: true,
    centeredSlidesBounds: true,
  })
}

new Swiper('.seedling-gallery', {
  thumbs: {
    swiper: thumbnails,
    autoScrollOffset: 3,
  },
})

Fancybox.bind('[data-gallery="seedling"]', {
  groupAll: true,
  Toolbar: {
    display: {
      left: [],
      middle: [],
      right: ['close'],
    },
  },
  Thumbs: {
    type: 'classic',
  },
})

const setCtaPos = () => {
  const card = document.querySelector('.card-layout')
  const cta = document.querySelector('.seedling-cta--air')

  if (!card || !cta) {
    return
  }

  const bodyWidth = document.body.clientWidth
  const cardWidth = card.clientWidth
  const pos = (bodyWidth - cardWidth) / 2 + 30

  cta.style.right = `${pos}px`
}

window.addEventListener('load', setCtaPos)
window.addEventListener('resize', setCtaPos)

document.addEventListener('DOMContentLoaded', function () {
  const adminBar = document.querySelector('#wpadminbar')
  const gap = 30
  const header = 70
  const top = adminBar ? adminBar.clientHeight + gap + header : gap + header
  new hcSticky('.seedling-sticky', {
    top,
  })
})

new Swiper('.seedling-offers__slider', {
  slidesPerView: 1,
  spaceBetween: 15,
  navigation: {
    nextEl: '.offers-block__nav--next',
    prevEl: '.offers-block__nav--prev',
  },
})

let modal, modalInstance
$('.seedling-pdf').on('click', function (e) {
  e.preventDefault()
  e.stopPropagation()

  const button = $(this)

  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    xhrFields: {
      responseType: 'blob',
    },
    data: {
      id: button.attr('data-id') * 1,
      _ajax_nonce: object.nonce,
      action: 'casanova_get_seedling_pdf',
    },
    beforeSend: () => {
      modal = modalAlertTemplate({
        body: object.pdfPending,
        classes: 'casanova-pdf-modal',
      })

      $('body').append(modal)

      modalInstance = new Modal($('.casanova-pdf-modal')[0])
      modalInstance.show()
    },
    success: (data) => {
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(data)
      a.href = url
      a.download = button.attr('data-title') + '.pdf'
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
      modalInstance.hide()
      $(modal).remove()
    },
  })
})
